import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { FileProvider } from '../file.provider';
import { StoredFile } from '../../model/file';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { I18N } from 'ess-plugin-base';

@Component({
    selector: 'file-searchbox',
    templateUrl: './file.searchbox.html',
    styleUrls: ['./file.searchbox.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    providers: [FileProvider]
})
export class FileSearchbox {

    // files: File[] = [];

    @Input('suggest-visible')
    suggestVisible: boolean = true;

    @Output('success')
    success: EventEmitter<any> = new EventEmitter();

    // root: string = 'D://';
    
    searchInput : Subject<string> = new Subject();

    searchAction: Subscription = null;

    phrase: string = '';

    mode: string = 'filename';      // can also be 'content'..

    suggestions: string[] = [];

    constructor(private fileProvider: FileProvider, public i18n: I18N) {
        this.searchAction = this.searchInput.pipe(
            debounceTime(300),
            distinctUntilChanged()
        ).subscribe(value =>{
            this.phrase = value;
            this.doSearch(value);
            //value will have your input
        });
    }

    searchFor(event){
        this.searchInput.next(event);
    }

    doSearch(value: string) {
        this.phrase = value;
        this.suggestions = [];

        if (!this.phrase || !this.phrase.length) {
            return;
        }
        // console.log('Searching for ' + this.phrase);
            
        let byContent = (this.mode == 'content');

        this.fileProvider.searchFiles(this.phrase, byContent)
        .then(data => {
            if (data) {
                // this.files = [];
                if (data && data['suggestions']) {
                    this.suggestions = data['suggestions'];
                    //                     for(let item of data['suggestions']) {
                    //     this.
                    //     let f = new File().read(item);
                    //     f.is_dir = (f.size > 0);
                    //     this.files.push(f);
                    // }
                }
                this.success.emit(data);
            }
        });
    }

    open(file: StoredFile) {
        if (file.size > 0) {
            // a file
        }
    }
}